var render = function render(){var _vm=this,_c=_vm._self._c;return _c('chain-table-cell',{attrs:{"width":_vm.width,"value":_vm.value}})
}
var staticRenderFns = []

export { render, staticRenderFns }